export function computeLightingOverallPct(
  pageProgress: Map<number, { phase: string; pct?: number; completedTiles?: number; totalTiles?: number; verifiedSoFar?: number; totalToVerify?: number }>,
  totalPages: number
): number {
  if (totalPages <= 0) return 0;

  // Overall progress is page-share based:
  // done pages count as 1.0, in-progress pages contribute pct/100.
  let completedPageEquivalents = 0;
  Array.from(pageProgress.values()).forEach((pp) => {
    if (pp.phase === 'done') {
      completedPageEquivalents += 1;
      return;
    }
    const pagePct = Math.max(0, Math.min(pp.pct || 0, 100));
    completedPageEquivalents += pagePct / 100;
  });

  return Math.min(Math.round((completedPageEquivalents / totalPages) * 100), 100);
}
